import { v4 as uuid } from 'uuid';

function convertModifiers(modifierGroups, selectedModifiers) {
  const modifiers = [];
  let priceTotalCents = 0;

  // Iterate modifierGroups in menu order so cart display follows the order the
  // user sees in the item modal (e.g., Temperature, Toppings, Sides) rather than
  // the order the user happened to tap modifiers in.
  modifierGroups.forEach((group) => {
    group.modifiers.forEach((modifier) => {
      const selectedModifier = selectedModifiers.find(m => m.menuItemId === modifier.menuItemId);

      if (!selectedModifier) return;

      const hasNestedModifiers = selectedModifier.modifiers?.length > 0 && modifier.modifierGroups?.length > 0;

      const nested = hasNestedModifiers
        ? convertModifiers(modifier.modifierGroups, selectedModifier.modifiers)
        : null;

      const modifierPricePerItemCents = Math.round(modifier.price * 100);
      const modifierPriceTotalCents = (modifierPricePerItemCents * selectedModifier.quantity) + (nested ? nested.priceTotalCents : 0);

      priceTotalCents += modifierPriceTotalCents;

      modifiers.push({
        menuItemId: modifier.menuItemId,
        itemDescription: modifier.description,
        quantity: selectedModifier.quantity,
        priceTotal: modifierPriceTotalCents / 100,
        ...nested && { modifiers: nested.modifiers }
      });
    });
  });

  return { modifiers, priceTotalCents };
}

function convertToOrderItem(newItem, menu, orderItemId) {
  const menuItem = menu.items.find(i => i.menuItemId === newItem.menuItemId);

  const pricePerItemCents = Math.round(menuItem.price * 100);

  const { modifiers, priceTotalCents: modifiersPriceTotalCents } = convertModifiers(menuItem.modifierGroups, newItem.modifiers);

  const priceTotalCents = (pricePerItemCents * newItem.quantity) + modifiersPriceTotalCents;

  const orderItem = {
    categoryId: newItem.categoryId,
    menuItemId: menuItem.menuItemId,
    isUpsell: newItem.isUpsell,
    itemDescription: menuItem.description,
    modifiers,
    orderItemId: orderItemId || uuid(),
    priceTotal: priceTotalCents / 100,
    quantity: newItem.quantity,
    specialInstructions: newItem.specialInstructions
  };

  return orderItem;
}



export default convertToOrderItem;
